
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const userManager = namespace("userManager");
const roleManager = namespace("roleManager");
@Component({})
export default class resurce extends Vue {
  dialogVisible: boolean = false;
  loading: boolean = false;

  @Prop({ type: Object, default: null }) value: Object;
  ruleForm: any = {
    roleName: ""
  };
  rules: any = {};
  menuList: any = [];
  resourceCodeList: any = [];
  defaultProps: any = {
    children: "children",
    label: "menuName"
  };
  @roleManager.Action bindRoleResource;
  @roleManager.Action getMenuListByRole;
  async created() {
    this.menuList = await this.getMenuListByRole({
      menuType: "2"
    });
  }
  /**
   * 回显被绑定的值
   */
  @Watch("value")
  onEditDataChange(obj) {
    try {
      this.ruleForm = obj;
      let nodeKeys = obj.resource.map(i => i.resourceCode);
      // 判断是否有父子关系，子节点不全选中，移除该子节点的父节点。
      // 判断当前元素是否为父节点（是否有子节点），且其子节点都在数组中？不全在数组中则从数组中移除
      // 只要把所有父节点都移除就可以了（只选了父节点不能移除），当前节点下面children有值（选了子节点，父节点必选）。
      const removedParentNodes = (resourceArr, menuList) => {
        const CODE_KEY = "resourceCode";
        const CHILD_KEY = "children";
        const canRemoveChildNode = (arr, node, resourceArr) => {
          for (let item of arr) {
            const childs = item[CHILD_KEY];
            const nodeIdx = item[CODE_KEY];
            const hasChild = node === nodeIdx && childs && childs.length !== 0;
            // 可递归，这里只有一层，简易处理
            if (hasChild) {
              // 只有该父节点在数组中，要保留
              const currentChildNodes = childs.map(el => el[CODE_KEY]);
              // 求数组交集
              const intersections = resourceArr.filter(v =>
                currentChildNodes.includes(v)
              );
              // console.log(intersections, currentChildNodes, arr, 'intersections')
              return intersections.length > 0;
            }
          }
        };
        return resourceArr.filter(
          node => !canRemoveChildNode(menuList, node, resourceArr)
        );
      };
      this.$nextTick(() => {
        const restNodes = removedParentNodes(nodeKeys, this.menuList);
        // console.log(restNodes);
        // 设置选中的节点
        let tree = (this as any).$refs.tree;
        tree && tree.setCheckedKeys(restNodes);
      });
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * 选择绑定的父子节点
   */
  handleCheckChange(a, b, c, d) {
    const { checkedKeys: childNodes, halfCheckedKeys: parentNodes } = b;
    this.resourceCodeList = [...childNodes, ...parentNodes];
  }
  async handleSubmit() {
    this.loading = true;
    const uniqueList = Array.from(new Set(this.resourceCodeList));
    await this.bindRoleResource({
      param: {
        appCode: this.getGlobalAppCode(), // 生产上的APP_CODE不一样
        resourceCodeList: uniqueList,
        roleCode: this.ruleForm.roleCode || "",
        resourceType: "2"
      }
    })
      .then(_ => {
        this.$emit("refresh", 1);
        this.dialogVisible = false;
        this.$message({ type: "success", message: "绑定成功" });
      })
      .finally(_ => {
        this.loading = false;
      });
  }
  getGlobalAppCode() {
    try {
      return (window as any).__GTECH_VARIABLES_APP_CODE__;
    } catch (error) {
      console.log(error);
    }
  }
}
